// Tiny helpers shared across pages
export function PageHeader({ title, subtitle, actions, testId, icon: Icon, accent }) {
  return (
    <div
      className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 sm:gap-4 mb-5 sm:mb-7"
      data-testid={testId}
    >
      <div className="min-w-0">
        <div className="text-[10px] uppercase tracking-[0.16em] text-[#737A76] mb-1.5">Park Director</div>
        <h1
          className="text-2xl sm:text-3xl font-semibold tracking-tight text-[#1A211D] flex items-center gap-2"
          style={{ fontFamily: "Outfit", color: accent }}
        >
          {Icon ? <Icon size={22} className="shrink-0" /> : null}
          <span className="truncate">{title}</span>
        </h1>
        {subtitle && <p className="text-xs sm:text-sm text-[#737A76] mt-1">{subtitle}</p>}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-wrap sm:flex-nowrap sm:shrink-0 -mx-1 px-1 overflow-x-auto sm:overflow-visible">
          {actions}
        </div>
      )}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    Active: "bg-[#E3F0E6] text-[#297343]",
    Reservation: "bg-[#FFF4D4] text-[#946A00]",
    Closed: "bg-[#F0F0EC] text-[#737A76]",
    Cancelled: "bg-[#F5E3E0] text-[#A13E34]",
    Open: "bg-[#FFF4D4] text-[#946A00]",
    Paid: "bg-[#E3F0E6] text-[#297343]",
    Partial: "bg-[#F5E3E0] text-[#A13E34]",
    Void: "bg-[#F0F0EC] text-[#737A76]",
  };
  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium ${map[status] || "bg-[#F0F0EC] text-[#737A76]"}`}>
      {status}
    </span>
  );
}

export function formatCurrency(n) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return iso;
  }
}
